import React from "react";
import { useSelector } from "react-redux";
import Reward from "react-rewards";
import _ from "lodash";

import { database, auth } from "../firebase.config";
import DownloadDialogue from "./DownloadDialogue";
import noCover from "../illustrations/undraw_blank_canvas_3rbb.svg";
import history from "../router/history";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import CardHeader from "@material-ui/core/CardHeader";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: 230,
    marginBottom: 8,
  },
  details: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    paddingBottom: 45,
  },
  content: {
    paddingTop: 0,
  },
  cover: {
    minWidth: 150,
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  actions: {
    position: "absolute",
    bottom: 0,
    height: 45,
  },
}));

export default function BookCard(props) {
  const classes = useStyles();
  var reward = null;

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLogin = () => {
    history.push("/Signin");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const readingList = useSelector((state) => state.readingList);

  const [downloadDialogueOpen, setDownloadDialogueOpen] = React.useState(false);

  const openDownloadLinksDialogue = () => {
    setDownloadDialogueOpen(true);
  };

  const closeDownloadLinksDialogue = () => {
    setDownloadDialogueOpen(false);
  };

  const renderPublisher = (publisher) => {
    if (publisher) {
      return (
        <Typography variant="body2" color="textSecondary" component="p">
          {`Publisher: ${publisher}`}
        </Typography>
      );
    } else {
      return null;
    }
  };

  const renderDescription = (description) => {
    if (description) {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
        >{`Description: ${description.substring(0, 250)}...`}</Typography>
      );
    } else {
      return null;
    }
  };

  const renderCover = (cover) => {
    if (cover) {
      return cover;
    } else {
      return noCover;
    }
  };

  const renderSubHeader = (authors) => {
    if (authors) {
      return `By: ${authors.toString().split(",").join(", ")}`;
    } else {
      return "Unknown Author";
    }
  };

  const renderDownloadDialogue = () => {
    if (downloadDialogueOpen) {
      return (
        <DownloadDialogue
          title={props.title}
          authors={props.authors}
          bookId={props.id}
          closeDownloadLinksDialogue={closeDownloadLinksDialogue}
        />
      );
    } else {
      return null;
    }
  };

  const renderAddToReadingListButton = () => {
    if (_.keys(readingList).includes(props.id)) {
      return (
        <Button
          color="primary"
          onClick={() => AddToReadingList(reward)}
          disabled
        >
          Added to Reading List
        </Button>
      );
    } else {
      return (
        <Button color="primary" onClick={() => AddToReadingList(reward)}>
          Add to Reading List
        </Button>
      );
    }
  };

  const AddToReadingList = async (reward) => {
    if (auth.currentUser !== null) {
      reward.rewardMe();

      const bookData = {
        id: props.id,
        title: props.title ? props.title : "",
        authors: props.authors ? props.authors : "",
        publisher: props.publisher ? props.publisher : "",
        description: props.description ? props.description : "",
        cover: props.cover ? props.cover : "",
        rating: props.rating,
      };

      await database
        .collection("users")
        .doc(auth.currentUser.uid)
        .collection("ReadingList")
        .doc(bookData.id)
        .set(bookData);
    } else {
      handleClickOpen();
    }
  };

  return (
    <>
      <Card className={classes.root} variant="outlined">
        <CardMedia
          className={classes.cover}
          image={renderCover(props.cover)}
          title={props.title}
        />
        <div className={classes.details}>
          <CardHeader
            // action={
            //   <IconButton aria-label="settings">
            //     <MoreVertIcon />
            //   </IconButton>
            // }
            title={props.title}
            subheader={renderSubHeader(props.authors)}
          />
          <CardContent className={classes.content}>
            {renderPublisher(props.publisher)}
            {renderDescription(props.description)}
          </CardContent>
          <CardActions className={classes.actions}>
            <Reward
              ref={(ref) => {
                reward = ref;
              }}
              type="confetti"
            >
              {renderAddToReadingListButton()}
            </Reward>
            <Button color="primary" onClick={openDownloadLinksDialogue}>
              Download
            </Button>
            {renderDownloadDialogue()}
          </CardActions>
        </div>
      </Card>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Please login in order to add this book to your reading list."}
        </DialogTitle>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancle
          </Button>
          <Button onClick={handleLogin} color="primary" autoFocus>
            Login
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
